import { render } from "./buttons.vue?vue&type=template&id=1b6d7116&scoped=true"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"

import "./buttons.vue?vue&type=style&index=0&id=1b6d7116&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6d7116"]])

export default __exports__